import { React, useState } from 'react';
import { Form, Image, Input, Spin } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import 'antd/dist/antd.css';
import style from './auth.module.scss';
import axios from './../../config/apiConfig';
import { CustomButton, message } from './../utils/Utils';
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
// import animatedLogo from `${process.env.REACT_APP_PUBLIC_ASSETS}/logo.gif`;

const Login = () => {
  const { passInput, loginContainer } = style;

  const history = useHistory();
  const [userNotFound, setUserNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const logoUrl = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/logo.gif`;

  const onFinish = async (values) => {
    setIsLoading(true);
    try {
      const user = { userPassword: values.userPassword };
      if (values.emailOrAcc.indexOf('@') === -1) {
        user.accountNumber = values.emailOrAcc;
      } else {
        user.email = values.emailOrAcc;
      }
      const { data } = await axios.post('/login', user);
      localStorage.setItem('jwt', data.data[0].token);
      localStorage.setItem('id', data.data[0].userId);
      getUser(data.data[0].userId);
    } catch (error) {
      if (error.response.status === 403) {
        history.push('/accessRestricted');
      } else {
        setUserNotFound(true);
        setIsLoading(false);
        message.error('Error al iniciar sesión');
      }
    }
  };

  const getUser = async (user) => {
    try {
      const { data } = await axios.get(`/users/${user}`);
      if (data.data[0].isAdmin) {
        localStorage.setItem('role', 'admin');
        history.push('/admin');
      } else {
        localStorage.setItem('role', data.data[0].role);
        if (data.data[0].role === 'pharmacy') {
          const response = await axios.get('/orders');
          const combosBought = response.data.data[0].orders.map((order) => {
            return order.combo;
          });
          localStorage.setItem('combosBought', JSON.stringify(combosBought));
        }
        const URLToRedirect =
          data.data[0].role === 'supplier' ? '/provider' : '/signPage/entry';
        setIsLoading(false);
        message.success('¡Ingreso con éxito!', 0.5);
        history.push(URLToRedirect);
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  const onFieldsChange = () => {
    setUserNotFound(false);
  };

  return (
    <>
      <div className={loginContainer}>
        <div>
          <div>
            <Image preview={false} src={logoUrl} alt="" />
          </div>
          <div>
            <h1>BIENVENIDO/A EXPO SUIZA 2024</h1>
            <div>
              <h2>Ingresar</h2>
              <Form
                labelCol={{
                  span: 7,
                }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onFieldsChange={onFieldsChange}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <Form.Item
                  className="loginHelp"
                  help="Si posee cuenta farmacéutica utilice número de cuenta"
                ></Form.Item>
                <Form.Item
                  label=""
                  name="emailOrAcc"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese su email o número de cuenta',
                    },
                  ]}
                >
                  <Input placeholder="Email o número de cuenta" />
                </Form.Item>
                <h3> Contraseña </h3>
                <Form.Item
                  label=""
                  name="userPassword"
                  rules={[
                    {
                      required: true,
                      message: 'Por favor ingrese su contraseña',
                    },
                  ]}
                  {...(userNotFound
                    ? {
                      validateStatus: 'error',
                      help: 'Email, número de cuenta o contraseña incorrecta',
                    }
                    : '')}
                >
                  <Input.Password
                    placeholder="Password"
                    type="password"
                    className={passInput}
                  />
                </Form.Item>
                <Form.Item className="login_singInBtn">
                  <div>
                    {isLoading ? (
                      <Spin indicator={antIcon} />
                    ) : (
                      <CustomButton
                        htmlType="submit"
                        content="Ingresar"
                        color="btnPrimary"
                        size="bg"
                        style={{ width: 'unset' }}
                      />
                    )}
                  </div>
                </Form.Item>
                <Link to="/signPage/passRecovery">
                  ¿Olvidaste tu contraseña?
                </Link>
              </Form>
            </div>
            <div>
              <a
                href="https://www.instagram.com/drogueriasuiza.ok/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined />
                /DROGUERIASUIZATUC
              </a>
              <a
                href="https://facebook.com/DROGUERIASUIZA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookOutlined />
                /DROGUERIASUIZA
              </a>
              <a
                href="http://www.dsuiza.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GlobalOutlined />
                WWW.DSUIZA.COM.AR
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
